'use strict';

export class PeriodicReportingCtrl
{
	$scope;
	$filter;
	jsDataService;
	$mdDialog;
	classif;
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;
		this.classif = this.jsDataService.get('cfgClassif', {});
		
	}
	
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
	
	actConfirmEdit(ev){
		const confirmTexts = this.jsDataService.get('editConfirmTexts');
		const confirm = this.$mdDialog.confirm()
			.title(confirmTexts.title)
			.htmlContent(confirmTexts.content)
			.ariaLabel(confirmTexts.title)
			.targetEvent(ev)
			.ok(confirmTexts.ok)
			.cancel(confirmTexts.cancel);
		this.$mdDialog.show(confirm).then(() => {
			this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('cfgEditConfirmUrl'),
				method: 'GET',
				params: {}
			}).then((results) => {
				if(results.data.success){

				}
			});
		}, () => {});
	}
	
	getClassifValue(value, classifName){
		if(this.classif && typeof(this.classif[classifName]) !== 'undefined'){
			let v = this.$filter('filter')(this.classif[classifName], {id: value}, true);
			if(v.length > 0){
				return v[0].title;
			}
		}
		return '';
	}
	
	actConfirmResolution(ev){
		const confirmTexts = this.jsDataService.get('resolutionConfirmTexts');
		const confirm = this.$mdDialog.confirm()
			.title(confirmTexts.title)
			.htmlContent(confirmTexts.content)
			.ariaLabel(confirmTexts.title)
			.targetEvent(ev)
			.ok(confirmTexts.ok)
			.cancel(confirmTexts.cancel);
		this.$mdDialog.show(confirm).then(() => {
			this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('cfgResolutionConfirmUrl'),
				method: 'GET',
				params: {}
			}).then((results) => {
				if(results.data.success){

				}
			});
		}, () => {});
	}
	
	actConfirmObservations(ev){
		const confirmTexts = this.jsDataService.get('observationsConfirmTexts');
		const confirm = this.$mdDialog.confirm()
			.title(confirmTexts.title)
			.htmlContent(confirmTexts.content)
			.ariaLabel(confirmTexts.title)
			.targetEvent(ev)
			.ok(confirmTexts.ok)
			.cancel(confirmTexts.cancel);
		this.$mdDialog.show(confirm).then(() => {
			this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('cfgobservationsConfirmUrl'),
				method: 'GET',
				params: {}
			}).then((results) => {
				if(results.data.success){

				}
			});
		}, () => {});
	}
	
}